'use client'
import { useEffect, useState } from 'react'

export const defaultHeaderHeight = 70
export const defaultHeaderHeightPx = `${defaultHeaderHeight}px`

export function useHeaderHeight(hiddenHeader: boolean) {
  const [headerHeight, setHeaderHeight] = useState(defaultHeaderHeight)

  useEffect(() => {
    const headerHeightValue = hiddenHeader ? 0 : defaultHeaderHeight
    document.body.style.setProperty('--mantine-header-height', `${headerHeightValue}px`)
    setHeaderHeight(headerHeightValue)
  }, [hiddenHeader])

  return headerHeight
}
